import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/hkasharmony.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import LineImg from "../assets/Images/line.png";
import HarmonyImg from "../assets/Images/harmonylogo.png";
import "./AboutCharterPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import Vid1 from "../assets/Videos/about_charter_combined.mp4";
// import Vid2 from "../assets/Videos/about_charter_video2.mp4";
// import Vid3 from "../assets/Videos/about_charter_video3.mp4";
// import Vid4 from "../assets/Videos/about_charter_video4.mp4";


const AboutCharterPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("about_charter_page_header")}</h1>
          <p className="banner-subtitle">{t("about_charter_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_about_charter_page_link1")}</Link>
        <span>{t("breadcrumbs_about_charter_page_span")}</span>
        <Link>{t("breadcrumbs_about_charter_page_link2")}</Link>
      </Breadcrumbs>
      <main className="charter-main-container">
        <section className="charter-logo-section">
          <img className="charter-logo" src={HarmonyImg} alt="Harmony Charter logo" />
        </section>
        
        <section className="charter-content-section">
          <div className="charter-text-container">
            <p className="charter-paragraph">{t("about_charter_page_text1")}</p>
            <p className="charter-paragraph">{t("about_charter_page_text2")}</p>
            <p className="charter-paragraph">{t("about_charter_page_text3")}</p>
            <p className="charter-paragraph">{t("about_charter_page_text4")}</p>
            <p className="charter-paragraph">{t("about_charter_page_text5")}</p>
          </div>
        </section>

        <section className="charter-video-section">
            <div>
              <ReactPlayer
                url={Vid1}
                controls={true}
                width="100%"
                height="100%"
                onError={(e) => console.error('Video failed to load:', e)}
                fallback={<p style={{color: '#AD172B', textAlign: 'center', padding: '40px'}}>
                  Video is currently unavailable. Please try again later.
                </p>}
              />
            </div>
          </section>

        <div className="charter-divider">
          <img src={LineImg} alt="Decorative line" className="divider-line" />
        </div>
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" className="bottom-logo" />
      </div>

      <Footer />
    </>
  );
};

export default AboutCharterPage;
